<template>
    <div class="slider">
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div class="tick-holder">
            <div v-for="choice in question.max"
                :key="choice"
                :class="['tick', { selected: response != null && response.hasOwnProperty(choice - 1) }]">
                <span class="tick-int">
                    {{ choice }}
                </span>
                <span class="tick-text">
                    {{ question.label[choice - 1] }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>

export default {   
    name: 'slider-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Object,
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
